export const educationData = [
    {
        id: 1,
        institution: 'SSM',
        course: 'Higher Secondary Education',
        startYear: '2018',
        endYear: '2019'
    },
    {
        id: 2,
        institution: 'VITS, Satna',
        course: 'Bachelor of Technology',
        startYear: '2019',
        endYear: '2023'
    },
]